type SearchModeSetter = (mode: 'search') => void

export function dismissComposer(setMode: SearchModeSetter): void {
  setMode('search')
}
